export const ec2AutoInstanceHeader = {
  'hdsw-ec2-auto-instance': 'true',
};
